import type { TTerm } from '@/types'
import { LOCALES } from '@/common'
import { SOURCES, TAGS, TYPES } from '@/data/raw'

export default {
  id: `legacy_migration`,

  name: {
    [LOCALES.EN_US]: `Legacy Migration`,
  },

  label: {
    [LOCALES.EN_US]: ``,
  },

  definition: {
    [LOCALES.EN_US]: ``,
  },

  type: [TYPES.methodology],

  tags: [],
} as const satisfies TTerm
